var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", { attrs: { for: "" } }, [_c("span", [_vm._t("default")], 2)]),
      _c("TreeSelect", {
        attrs: { options: _vm.data },
        model: {
          value: _vm.selectedItems,
          callback: function ($$v) {
            _vm.selectedItems = $$v
          },
          expression: "selectedItems",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }